import React from 'react'
import { ColumnRank, ColumnBib, ColumnName, ColumnNoc, ColumnExpander } from "components/common/TableColumns"
import WlfAttempt from 'components/sports/wlf/views/WlfAttempt';
import SportCode from 'components/common/SportCode'
import { findArray, RscFromStore, filterArray } from "helpers/utils";
import { getRscObject, getEventRSC, getLongEventRSC } from 'helpers/rsc';
import Label from "components/general/Label"

export default function WlfTableColumnsSMFinished(hasRecordTotal, hasRecordSnatch, hasRecordClean) {

  return (
    [

      ColumnRank({}),
      ColumnNoc({}),
      ColumnName({}),
      {
        id: "Snatch-Result",
        Header: <Label data='HeaderSnatch' sport='WLF' />,
        headerClassName: 'text-end w-20',
        className: 'text-end',
        accessor: (props) => {
          let extendedResults = props?.extendedResults?.find(row => row.er_code === 'SNATCH' && row.er_pos === 'TOTAL')
          let record = extendedResults?.extensions?.find(row => row.ere_code === 'RECORD' && row.ere_pos === '1')?.ere_value
          return (
            <div className="d-flex flex-row justify-content-end" >
              <div className="ms-1 w-60 text-end">
                <WlfAttempt data={props} code='SNATCH' pos='TOTAL' />
              </div>
              <div className={`text-end w-40 ${hasRecordSnatch ? '' : 'd-none'}`}>
                {record}
              </div>
            </div>
          )
        },
      },
      {
        id: "Clean-Result",
        Header: <Label data='HeaderClean' sport='WLF' />,
        headerClassName: 'text-end w-20',
        className: 'text-end',
        accessor: (props) => {
          let extendedResults = props?.extendedResults?.find(row => row.er_code === 'CLEAN' && row.er_pos === 'TOTAL')
          let record = extendedResults?.extensions?.find(row => row.ere_code === 'RECORD' && row.ere_pos === '1')?.ere_value
          return (
            <div className="d-flex flex-row justify-content-end" >
              <div className="ms-1 w-60 text-end">
                <WlfAttempt data={props} code='CLEAN' pos='TOTAL' />
              </div>
              <div className={`text-end w-40 ${hasRecordClean ? '' : 'd-none'}`}>
                {record}
              </div>
            </div>
          )
        },
      },
      ColumnResultRecords({ className: 'fw-bold text-end', hasRecord: hasRecordTotal }),
      ColumnExpander({ type: 'extendedResults', erCode: 'SNATCH' })
    ]
  )
}

function ColumnResultRecords({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-20',
  remove = false,
  hasRecord
}) {
  return (
    {
      Header: <Label data='HeaderTotal' sport='WLF' />,
      accessor: 'SortOrder',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      id: 'ResultTotal',
      remove: remove,

      Cell: (props) => {
        let row = props.cell.row.original
        let rsc = RscFromStore()
        let discipline = getRscObject(rsc).discipline
        let event = getLongEventRSC(rsc)
        let rowNumberIrm = findArray(row.extendedResults, { er_code: ['IRM_LAP'] })
        let numberIrm = rowNumberIrm?.er_value || ''
        let resultIrm = (row.resultIrm)
        let recordEvent = getEventRSC(rsc)
        let min = 1;

        let arrRecordIndicator = filterArray(row.recordIndicators, { ri_code: [event] });
        if (Array.isArray(arrRecordIndicator) && arrRecordIndicator.length > 0) {
          min = Math.min.apply(Math, arrRecordIndicator.map(function (o) {
            return o.ri_order;
          }));
        }

        row?.recordIndicators
          ? props.cell.row.original.recordIndicators.filter(row => row.ri_order === min && getEventRSC(row.ri_code) === recordEvent).map((val) => {
            arrRecordIndicator = (val.ri_equalled === 'Y' ? '=' : '') + val.ri_recordtype
          })
          : arrRecordIndicator = ''

        let irmObject = {}
        switch (resultIrm) {
          case 'DNF':
            irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />{numberIrm}</>
            break;
          case 'LAP':
            irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} /></>
            break;
          default:
            irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />
            break;
        }

        return (
          props.cell.row.original.resultType === 'IRM'
            ? <div className="d-flex flex-row justify-content-end"><div className="ms-1 w-60 text-end">{irmObject}</div><div className={`text-end w-40 ${hasRecord ? '' : 'd-none'}`}>{arrRecordIndicator}</div></div>
            : <div className="d-flex flex-row justify-content-end"><div className="ms-1 w-60 text-end">{props.cell.row.original.resultData}</div><div className={`text-end w-40 ${hasRecord ? '' : 'd-none'}`}>{arrRecordIndicator}</div></div>
        )
      },
    }
  )
}
